export default "__VITE_ASSET__8bcee8fb__"